<!-- Port Charges Management Modal -->
<div class="modal-backdrop fade show" *ngIf="showModal" (click)="close()"></div>
<div class="modal fade show d-block" *ngIf="showModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width: 90vw;">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header border-bottom-0 pb-0">
        <div class="w-100">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="modal-title mb-0">Port Charges Management</h5>
            <button type="button" class="btn-close" (click)="close()"></button>
          </div>

          <!-- Modal Header Content -->
          <div class="mb-4">
            <h4 class="mb-1">
              <i class="bi bi-shop text-primary me-2"></i>Port Charges Management
            </h4>
            <p class="text-muted mb-0">Manage agent port assignments and origin charges in one place</p>
          </div>

          <!-- Tab Navigation -->
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <a
                class="nav-link"
                [class.active]="activeTab === 'port-charges'"
                (click)="switchTab('port-charges')"
                style="cursor: pointer;">
                <i class="bi bi-list-ul me-2"></i>Port Charges
              </a>
            </li>
            <!-- HIDDEN: Carriers tab
            <li class="nav-item">
              <a
                class="nav-link"
                [class.active]="activeTab === 'carriers'"
                (click)="switchTab('carriers')"
                style="cursor: pointer;">
                <i class="bi bi-truck me-2"></i>Carriers
              </a>
            </li>
            -->
            <!-- HIDDEN: Port Assignments tab
            <li class="nav-item">
              <a
                class="nav-link"
                [class.active]="activeTab === 'port-assignments'"
                (click)="switchTab('port-assignments')"
                style="cursor: pointer;">
                <i class="bi bi-gear me-2"></i>Port Assignments
              </a>
            </li>
            -->
          </ul>
        </div>
      </div>

      <!-- Modal Body - Tab Content -->
      <div class="modal-body" style="min-height: 500px;">
        <!-- Port Charges Tab -->
        <div *ngIf="activeTab === 'port-charges'" class="tab-content-wrapper">
          <app-port-charges-tab></app-port-charges-tab>
        </div>

        <!-- Carriers Tab -->
        <div *ngIf="activeTab === 'carriers'" class="tab-content-wrapper">
          <app-carriers-tab></app-carriers-tab>
        </div>

        <!-- Port Assignments Tab -->
        <div *ngIf="activeTab === 'port-assignments'" class="tab-content-wrapper">
          <app-port-assignments-tab></app-port-assignments-tab>
        </div>
      </div>
    </div>
  </div>
</div>
